import React, { FC, useMemo } from 'react';
import { ControlledAutocomplete, ControlledDatePicker, FormGrid, IOrganisation, Section } from '../../../shared';
import { Frequency } from '../../enums';
import { useTranslation } from 'react-i18next';
import { Appointment } from '../../../shared/enums/appointment.enum';

export interface Props {
    organisations: IOrganisation[];
}

export const SupportPeriodGeneralInputs: FC<Props> = ({ organisations }) => {
    const { t } = useTranslation();

    const organisationsWithSupportTypes = useMemo(() => {
        return organisations.filter((organisation) => organisation.supportTypes?.length > 0) || [];
    }, [organisations]);

    return (
        <Section title={t('general')}>
            <FormGrid size={{ xs: 12, md: 6 }}>
                <ControlledDatePicker name="startDate" label={t('startDateLabel')} />
                <ControlledDatePicker name="endDate" label={t('endDateLabel')} />
            </FormGrid>
            <FormGrid size={{ xs: 12, md: 4 }}>
                <ControlledAutocomplete
                    name="organisation"
                    label={t('preferredOrganisation')}
                    options={organisationsWithSupportTypes}
                    getOptionLabel={(option) => `${option.name} - ${option.type.name}`}
                    defaultValue={null}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                />
                <ControlledAutocomplete
                    name={`frequency`}
                    label={t('frequencyLabel')}
                    options={Object.values(Frequency)}
                    getOptionLabel={(option) => t(option)}
                    defaultValue={null}
                />
                <ControlledAutocomplete
                    name={`appointment`}
                    label={t('appointmentLabel')}
                    options={Object.values(Appointment)}
                    getOptionLabel={(option) => t(option)}
                    defaultValue={null}
                />
            </FormGrid>
        </Section>
    );
};
